// extracted by mini-css-extract-plugin
export default {"root":"Sessions_root__tMoDB","session":"Sessions_session__WY1ci","date":"Sessions_date__WkqSG","badge":"Sessions_badge__xcsQl","icon":"Sessions_icon__f201x"};